<div class="skeleton-form" [ngStyle]="gridStyle" [attr.data-qa]="testId">
  @for (item of arrayOfItems; track item) {
    <div class="skeleton-field">
      <div class="skeleton-label skeleton-element"></div>
      <div class="skeleton-input skeleton-element" [ngStyle]="{ height: inputHeight }"></div>
    </div>
  }
</div>
